module.exports = __webpack_public_path__ + "img/account.05417e67.png";